import { useTheme, useMediaQuery } from "@material-ui/core";

export const useIsLargeScreen = ( ) => {
  const theme = useTheme();
  return useMediaQuery( theme.breakpoints.up( 'md' ) );
}

export default useIsLargeScreen;